import React, { FC } from "react";

import { CatchTitleBorder, LinkTitleItem } from "~/components/atoms";
import { InfiniteScrollWithMoreButton } from "~/components/molecules";

import { MyRoutes } from "~/config/Paths";

import { EmployeeSurveyType } from "~/domains";

type PropsType = {
  title: string;
  employeeSurveys: EmployeeSurveyType[];
  fetchNextPage: () => void;
  hasMore?: boolean;
  className?: string;
  businessSectionId?: string;
};

export const EmployeeSurveyTitleInfinitiesScroll: FC<PropsType> = ({
  title,
  employeeSurveys,
  hasMore,
  className = "",
  businessSectionId = "",
  fetchNextPage,
}: PropsType) => {
  return (
    <div className={className}>
      <CatchTitleBorder text={title} />
      <InfiniteScrollWithMoreButton
        itemsLength={employeeSurveys.length}
        nextFetchFunction={fetchNextPage}
        hasMore={hasMore}
        className="mt-6"
        scrollClassName="space-y-6"
      >
        {employeeSurveys.map((item) => (
          <LinkTitleItem
            key={item.id}
            to={MyRoutes.Members.inputEmployeeSurveysShow({
              id: item.id,
              q: { business_section_id: businessSectionId },
            })}
            title={item.title}
          />
        ))}
      </InfiniteScrollWithMoreButton>
    </div>
  );
};
